/**
 * 平台差异全部收口在这里：
 *   - role：creator（达人）
 *   - platform：运行时判断 pc / h5
 *   - ModalShell：统一常驻 fixed shell（桌面全屏 / 移动端底部）
 *
 * App.tsx 只需 <TimModal />，对平台细节零感知。
 */
import React from 'react';
import { useTranslation } from 'react-i18next';
import { isMobile } from '@/biz/tool';
import { CloseIcon } from '@/components/common/icon';
import { Tracker } from '@/utils';
import TimModal from './TimModal';
import ModalShell from './ModalShell';
import type { TimOpenSource } from './useTimModalStore';

const CreatorTimModal: React.FC = () => {
  const { t } = useTranslation();

  const handleTrackFirstOpen = React.useCallback(
    ({
      source,
      role,
      platform
    }: {
      source: TimOpenSource;
      role: 'brand' | 'creator';
      platform: 'pc' | 'h5';
    }) => {
      Tracker.gtag('event', 'screen_view', {
        event_category: 'tim_panel_first_open',
        tim_open_source: source,
        role,
        platform,
        value: 1
      });
    },
    []
  );

  return (
    <TimModal
      role="creator"
      platform={isMobile() ? 'h5' : 'pc'}
      ModalShell={ModalShell}
      title={t('navbar.menu.messages', { defaultValue: 'Message' })}
      closeIcon={<CloseIcon className="w-[16px] h-[16px]" />}
      trackFirstOpen={handleTrackFirstOpen}
    />
  );
};

export default CreatorTimModal;
